/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  clearSelectedNotification,
  setIsLoading,
  setNotifications,
  setSelectedNotification,
  updateNotificationAsRead,
} from './actions';
import { NotificationModel } from './models';

export interface NotificationsState {
  isLoading: boolean;
  selectedNotification: string | undefined;
  notifications: {
    [id: string]: NotificationModel;
  };
}

const initialState: NotificationsState = {
  isLoading: false,
  selectedNotification: undefined,
  notifications: {},
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(setIsLoading, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(setSelectedNotification, (state, action) => {
    state.selectedNotification = action.payload;
  });

  builder.addCase(clearSelectedNotification, (state) => {
    state.selectedNotification = initialState.selectedNotification;
  });

  builder.addCase(setNotifications, (state, action) => {
    state.notifications = {
      ...state.notifications,
      ...(action.payload as { [id: string]: NotificationModel }),
    };
  });

  builder.addCase(updateNotificationAsRead, (state, action) => {
    state.notifications[action.payload.id] = {
      ...state.notifications[action.payload.id],
      ...action.payload,
    };
  });
});
